import i18next from "i18next";
import { inAppBrowserFunc } from "./inAppBrowser/inAppBrowser";
import { setCurrentWidget } from "../Redux/Reducers/deviceConfigReducer";
import { setShowLoginModal } from "../Redux/Reducers/appConfigReducer";
import { CLICKED, URL_IFRAME_RENDERER_CATEGORY, URL_RENDERER_CATEGORY } from "../config/Constant";
import { Platform } from "react-native";
import { sendAnalytics } from "../Redux/Actions/analyticsAction";
import { setRenderInfoPopup } from "../Redux/Actions/appConfigAction";
import { redirectToDeepLink } from "./deeplink";


export const nonCompWidgetClick = (widgetData) => {
    console.log("nonCompWidgetClick------", widgetData);

    return async (dispatch, getState) => {
        try {
            if (widgetData.widgetType?.toLowerCase() == "url renderer") {
                dispatch(sendAnalytics(URL_RENDERER_CATEGORY , CLICKED, { element: "widget", platform: Platform.OS, targetUrl: widgetData.targetUrl }))
                inAppBrowserFunc(widgetData.targetUrl);
                return;
            }

            if (widgetData.widgetType?.toLowerCase() == "guest details") {
                dispatch(setShowLoginModal(true));
                return;
            }

            dispatch(setRenderInfoPopup(true, { title: i18next.t('featureNotAvailable.heading'), subtitle: i18next.t('featureNotAvailable.sub_heading'), onContinue: () => {redirectToDeepLink(); dispatch(setRenderInfoPopup(false))}, primaryBtnLabel: i18next.t('featureNotAvailable.primary_button'), secondaryBtnLabel: i18next.t('featureNotAvailable.secondary_button')}))
        } catch (error) {
            console.log("error in on click", error);
        }
    }
}